import {
  callStripeCheckout,
  createStripeObjectInstance,
} from 'services/stripeService';
import { fireToast } from 'helpers/Toasts';

async function handleCallStripeCheckout(
  adId: number,
  selectedQuantity: number,
  phoneNumber?: string,
) {
  try {
    const { sessionId, connectedStripeAccountId } = await callStripeCheckout(
      adId,
      selectedQuantity,
      phoneNumber,
    );
    const stripe = await createStripeObjectInstance(connectedStripeAccountId);

    if (stripe) {
      stripe.redirectToCheckout({ sessionId: sessionId });
    }
  } catch (error) {
    fireToast({
      type: 'ERROR',
      text: 'Oops! Something went wrong, please try again later',
    });
  }
}

export { handleCallStripeCheckout };
